import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Group, TextInput, Stack, Alert, Anchor } from '@mantine/core';
import { useForm } from '@mantine/form';
import { apiClient } from '../../data/apiClient';
import { useCsrf } from '../../hooks/useCsrf';
import { IconExclamationCircle } from '@tabler/icons-react';

import './DeviceTagForm.css';

const DeviceTagForm: React.FC = () => {
    const { csrfToken } = useCsrf();
    const navigate = useNavigate();
    const [isCreating, setIsCreating] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            label: '',
        },
        validate: {
            label: value => (value ? null : 'Label is required'),
        },
    });
    const icon = <IconExclamationCircle />;
    const handleBack = () => {
        navigate('/device-tags');
    };

    const handleSubmit = async (values: typeof form.values) => {
        setIsCreating(true);
        setErrorMessage('');
        try {
            await apiClient.post(
                `api/device-tags`,
                JSON.stringify({ label: values.label }),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-XSRF-TOKEN': csrfToken || '',
                    },
                }
            );

            setIsCreating(false);
            navigate('/device-tags');
        } catch (err: unknown) {
            setIsCreating(false);
            setErrorMessage(err instanceof Error ? err.message : 'Request failed');
        }
    };

    return (
        <div className={'location-form'} style={{ paddingTop: '16px' }}>
            <Anchor onClick={handleBack}>Back</Anchor>
            <h2>Add a device tag</h2>
            <form onSubmit={form.onSubmit(handleSubmit)}>
                <Stack>
                    <TextInput
                        withAsterisk
                        label="Label"
                        placeholder="e.g. Bar area screens"
                        key={form.key('label')}
                        {...form.getInputProps('label')}
                    />

                    <Group justify="flex-end" mt="md">
                        <Button type="submit" disabled={!form.isValid()} loading={isCreating} c="black">
                            Create
                        </Button>
                    </Group>
                    {errorMessage ? (
                        <Alert variant={'light'} color="red" title="Error" icon={icon}>
                            {errorMessage}
                        </Alert>
                    ) : (
                        ''
                    )}
                </Stack>
            </form>
        </div>
    );
};

export default DeviceTagForm;
